<template>
	<div
		class="modal fade"
		ref="modal"
		tabindex="-1"
		role="dialog"
		aria-hidden="true"
	>
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-body">
					<h1 class="confirmation-title">
						{{ titleText }}
					</h1>
					<div class="confirmation-body">
						{{ bodyText }}
					</div>
					<div class="action-container">
						<button
							class="button button-transparent"
							@click="cancel"
						>
							{{ cancelText }}
						</button>
						<button
							class="button"
							@click="confirm"
							:class="buttonClass"
						>
							<i
								v-if="confirmationIcon"
								:class="confirmationIcon"
							></i>
							{{ confirmationText }}
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-dialog {
	max-width: 345px;
	margin: 0.5rem auto;
}

.modal-body {
	align-items: flex-start;
}

.confirmation-title {
	font-weight: 900;
	font-size: 16px;
	color: var(--gR-base-90);
	margin-bottom: 22px;
}

.confirmation-body {
	font-size: 12px;
	color: var(--sk-grey3);
}

.action-container {
	display: flex;
	justify-content: space-between;
	width: 100%;
	margin-top: 19px;
}

.modal-body .button,
.modal-body .button.button-primary {
	width: auto;
	min-width: auto;
	margin: 0;
	padding: 0px 10px 0px 10px;
}

.modal-body .button.button-primary {
	min-width: 96px;
}

.button-transparent,
.button-transparent:hover,
.button-transparent:active,
.button-transparent:focus {
	font-size: 12px;
	color: var(--sk-grey2);
}

.button i {
	font-size: 14px;
	margin-right: 10px;
	margin-left: 5px;
}
</style>

<script>
import { ConfirmationModalType } from "@/enums/ConfirmationModalType"

export default {
	name: "ConfirmationModal",
	data: function () {
		return {
			confirmed: null,
			titleText: "",
			bodyText: null,
			confirmationText: "Ok",
			confirmationIcon: null,
			cancelText: "Cancel",
			type: ConfirmationModalType.ORANGE
		}
	},
	computed: {
		buttonClass() {
			switch (this.type) {
				case ConfirmationModalType.ORANGE:
					return "button-primary"
				case ConfirmationModalType.RED:
					return "button-danger"
			}
		}
	},
	methods: {
		open(options) {
			if (options) {
				this.titleText = options.title ? options.title : ""
				this.bodyText = options.body ? options.body : null
				this.confirmationText = options.confirmation
					? options.confirmation
					: "Ok"
				this.confirmationIcon = options.confirmationIcon
					? options.confirmationIcon
					: null
				this.cancelText = options.cancel ? options.cancel : "Cancel"
				this.type =
					options.type != undefined
						? options.type
						: ConfirmationModalType.ORANGE
			}
			$(this.$refs.modal).modal("show")
			return new Promise((resolve) => {
				this.confirmed = resolve
			})
		},
		close() {
			$(this.$refs.modal).modal("hide")
		},
		confirm() {
			this.close()
			this.consumePromise(true)
		},
		cancel() {
			this.close()
			this.consumePromise(false)
		},
		consumePromise(didConfirm) {
			if (this.confirmed) {
				this.confirmed(didConfirm)
				this.confirmed = null
			}
		}
	}
}
</script>
